module.exports = __webpack_public_path__ + "img/znxg1.ec92ae6e.png";